import React from 'react';

const Icon = ({ size = '29', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 29 29" fill="none" {...other}>
            <path
                d="M14.775 4.683c.97 0 1.756.786 1.756 1.756v9.074h1.17a2.05 2.05 0 0 1 2.05 2.05v2.341a1.464 1.464 0 0 0 2.926 0V14.05h-1.462V9.367h1.462V5.854h1.757v3.513h1.464v4.683h-1.464v5.854a3.22 3.22 0 0 1-6.44 0v-2.342a.293.293 0 0 0-.292-.292H16.53v4.976h1.17v2.342H3.653v-2.342h1.171V6.439c0-.97.786-1.755 1.756-1.756h8.196ZM7.75 14.05H9.7l-.78 4.683h.361l4.323-4.683h-1.952l.781-4.683h-.36L7.75 14.05Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
